
import { Vue, Component } from "vue-property-decorator";
import { schoolService } from "@/api/settings/school";

@Component({})
export default class SchoolSelector extends Vue {
  tenantId: number = null;

  tenants = [];

  created() {
    this.getData();
  }

  getData() {
    schoolService.getUserSchools().then((result) => {
      this.tenants = result.items;
    });
  }

  change() {
    this.$emit("change", {
      tenantId: this.tenantId,
    });
  }
}
